// Firebase web-app config (project cardiac-health-b5d36, app "Cardiac Web Portal").
// These are public client identifiers, not secrets — API access is gated by
// Firebase security rules / FCM registration, not by hiding this file.
export const firebaseConfig = {
  apiKey: 'AIzaSyAFyU_brSsIOSYw7vpYIzwxIekK2bx_MfQ',
  authDomain: 'cardiac-health-b5d36.firebaseapp.com',
  projectId: 'cardiac-health-b5d36',
  storageBucket: 'cardiac-health-b5d36.firebasestorage.app',
  messagingSenderId: '385766105284',
  appId: '1:385766105284:web:a6bd4b6e16bba619252991',
};
